import React from "react";
import img41 from "../images/image41.png";
import img42 from "../images/image42.png";
import img43 from "../images/image43.png";
import img44 from "../images/image44.png";
import img45 from "../images/image45.png";
import img46 from "../images/image46.png";
import Footer from "../Footer";

const AlumsCare = () => {
  return (
    <div>
    <div style={{ padding: "20px" }}>
    <h2 style={{ textAlign: "center", fontSize: "1.5rem", marginBottom: "20px", fontFamily: "Inter" ,marginLeft: "15px"}}>
    Alums Care for TISS, Students, and Society
      </h2>
      
      <p style={{textAlign:"justify",marginRight:"15px", fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
        Considering the Alums of such a prestigious institution, dedicated to creating a significant societal
        impact, TISSAA has been actively collaborating with TISS, students, and regional causes such as education,
        sustainability, and healthcare. Through partnerships with relevant organizations, the association organizes
        meetings that appoint ambassadors to spearhead initiatives and raise awareness in these crucial areas.
      </p>
      <h2 style={{ textAlign: "left", fontSize: "1.5rem", marginBottom: "20px", fontFamily: "Inter" , marginLeft:"15px"}}>
        NAAC/NIFR Accreditation
      </h2>
      <p style={{ textAlign:"justify",marginRight:"15px",fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
        TISSAA actively supports its Alma Mater during the NAAC/NIFR accreditation processes by facilitating meaningful
        Alums engagement. In Mumbai and Bangalore, TISSAA organized meetings between Alums and relevant officials to
        gather valuable Alums feedback, which is crucial for the accreditation process. Alums are also encouraged to
        participate by filling out online feedback forms, contributing to the successful completion of these accreditation
        efforts and ensuring that TISS continues to uphold its high academic standards.
      </p>
      <h2 style={{ textAlign: "left", fontSize: "1.5rem", marginBottom: "20px", fontFamily: "Inter",marginLeft: "15px"  }}>
        Scholarship Initiatives
      </h2>
      <p style={{textAlign:"justify",marginRight:"15px", fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
        TISSAA's scholarship programs are pivotal in making quality education at TISS accessible to students, regardless
        of their financial background. The "TISSians Bond for a Cause" campaign underscores the Alums's commitment
        to supporting future generations of students. By raising funds for scholarships and collaborating with the Kothari
        and Shah Trust, TISSAA ensures that deserving students can pursue their studies uninterrupted, fostering a culture
        of giving back and creating a sustainable support system for future TISS students.
      </p>
      <h2 style={{ textAlign: "left", fontSize: "1.5rem", marginBottom: "20px", fontFamily: "Inter", marginLeft: "15px" }}>
        Initiatives for Student Engagement
      </h2>
      <p style={{textAlign:"justify",marginRight:"15px", fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
        TISSAA's student engagement initiatives, such as blood donation camps and photoshoots, play a key role in
        strengthening the bond between current students and Alums. The blood donation camp exemplifies TISSAA’s
        dedication to public health and community welfare, while the photoshoot initiative provides Alums with a chance
        to reconnect with their Alma Mater, reliving cherished memories. These activities not only foster Alums engagement
        but also uphold TISS's values of social responsibility and community spirit.
      </p>
      <h2 style={{ textAlign: "left", fontSize: "1.5rem", marginBottom: "20px", fontFamily: "Inter",marginLeft: "15px"  }}>
        Environment Care
      </h2>
      <p style={{ textAlign:"justify",marginRight:"15px",fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
        To ensure cleanliness, TISSAA has partnered with leading corporates and organizations to undertake cleanliness
        drives in Mumbai, from beach cleaning to road cleaning. TISSAA also supports Alums working for environmental
        causes, from waste management to green activities.
      </p>
      <h2 style={{ textAlign: "left", fontSize: "1.5rem", marginBottom: "20px", fontFamily: "Inter" ,marginLeft: "15px" }}>
        Blood Donation
      </h2>
      <p style={{textAlign:"justify",marginRight:"15px", fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
        The Blood Donation Camp, initiated by TISSAA in collaboration with HDFC Bank and Tata Memorial Hospital, was a
        significant step in promoting social responsibility. Inaugurated by TISS Vice Chancellor Prof. Shalini Bharat,
        the camp saw the active participation of Alums such as Prof. Bipin Jojo, Mahesh Poojary, Dr. Nitin Lata, and
        Waman, demonstrating the collective commitment of the TISS community to supporting public health initiatives and
        contributing to the welfare of society.
      </p>


      
      <div style={styles.scrollingContainer}>
        <div style={styles.scrollingContent}>
          <img src={img41} alt="Alumni Meet 1" style={styles.image} />
          <img src={img42} alt="Alumni Meet 2" style={styles.image} />
          <img src={img43} alt="Alumni Meet 3" style={styles.image} />
          <img src={img44} alt="Alumni Meet 4" style={styles.image} />
          <img src={img45} alt="Alumni Meet 5" style={styles.image} />
          <img src={img46} alt="Alumni Meet 6" style={styles.image} />
          {/* Duplicate images for seamless scrolling */}
          <img src={img41} alt="Alumni Meet 1" style={styles.image} />
          <img src={img42} alt="Alumni Meet 2" style={styles.image} />
          <img src={img43} alt="Alumni Meet 3" style={styles.image} />
          <img src={img44} alt="Alumni Meet 4" style={styles.image} />
          <img src={img45} alt="Alumni Meet 5" style={styles.image} />
          <img src={img46} alt="Alumni Meet 6" style={styles.image} />
        </div>
      </div>
      </div>
      <Footer/>
    </div>
    
  );
};

const styles = {
  scrollingContainer: {
    overflow: "hidden",
    position: "relative",
    width: "100%",
    height: "300px", // Adjust based on the image height
    marginBottom: "80px"
  },
  scrollingContent: {
    display: "flex",
    animation: "scroll 15s linear infinite",
    gap: "15px",
  },
  image: {
    width: "500px",
    height: "400px",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    
  },
};

// Add the animation styles globally
const stylesString = `
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}
`;

const GlobalStyles = () => (
  <style dangerouslySetInnerHTML={{ __html: stylesString }} />
);

export default () => (
  <>
    <GlobalStyles />
    <AlumsCare />
  </>
);





// import React from "react";
// import img41 from '../images/image41.png';
// import img42 from '../images/image42.png';
// import img43 from '../images/image43.png';
// import img44 from '../images/image44.png';
// import img45 from '../images/image45.png';
// import img46 from '../images/image46.png';

// const AlumsCare = () => {
//   return (
//     <div style={{ padding: "20px" }}>
//       <h1 style={{ textAlign: "center", fontSize: "2.5rem", marginBottom: "20px", fontFamily: "Inter" }}>
//         Alums Care for TISS, Students, and Society
//       </h1>
//       <p style={{ fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         Considering the Alums of such a prestigious institution, dedicated to creating a significant societal
//         impact, TISSAA has been actively collaborating with TISS, students, and regional causes such as education,
//         sustainability, and healthcare. Through partnerships with relevant organizations, the association organizes
//         meetings that appoint ambassadors to spearhead initiatives and raise awareness in these crucial areas.
//       </p>
//       <h2 style={{ textAlign: "left", fontSize: "2rem", marginBottom: "20px", fontFamily: "Inter" }}>
//         NAAC/NIFR Accreditation
//       </h2>
//       <p style={{ fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         TISSAA actively supports its Alma Mater during the NAAC/NIFR accreditation processes by facilitating meaningful
//         Alums engagement. In Mumbai and Bangalore, TISSAA organized meetings between Alums and relevant officials to
//         gather valuable Alums feedback, which is crucial for the accreditation process. Alums are also encouraged to
//         participate by filling out online feedback forms, contributing to the successful completion of these accreditation
//         efforts and ensuring that TISS continues to uphold its high academic standards.
//       </p>
//       <h2 style={{ textAlign: "left", fontSize: "2rem", marginBottom: "20px", fontFamily: "Inter" }}>
//         Scholarship Initiatives
//       </h2>
//       <p style={{ fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         TISSAA's scholarship programs are pivotal in making quality education at TISS accessible to students, regardless
//         of their financial background. The "TISSians Bond for a Cause" campaign underscores the Alums's commitment
//         to supporting future generations of students. By raising funds for scholarships and collaborating with the Kothari
//         and Shah Trust, TISSAA ensures that deserving students can pursue their studies uninterrupted, fostering a culture
//         of giving back and creating a sustainable support system for future TISS students.
//       </p>
//       <h2 style={{ textAlign: "left", fontSize: "2rem", marginBottom: "20px", fontFamily: "Inter" }}>
//         Initiatives for Student Engagement
//       </h2>
//       <p style={{ fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         TISSAA's student engagement initiatives, such as blood donation camps and photoshoots, play a key role in
//         strengthening the bond between current students and Alums. The blood donation camp exemplifies TISSAA’s
//         dedication to public health and community welfare, while the photoshoot initiative provides Alums with a chance
//         to reconnect with their Alma Mater, reliving cherished memories. These activities not only foster Alums engagement
//         but also uphold TISS's values of social responsibility and community spirit.
//       </p>
//       <h2 style={{ textAlign: "left", fontSize: "2rem", marginBottom: "20px", fontFamily: "Inter" }}>
//         Environment Care
//       </h2>
//       <p style={{ fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         To ensure cleanliness, TISSAA has partnered with leading corporates and organizations to undertake cleanliness
//         drives in Mumbai, from beach cleaning to road cleaning. TISSAA also supports Alums working for environmental
//         causes, from waste management to green activities.
//       </p>
//       <h2 style={{ textAlign: "left", fontSize: "2rem", marginBottom: "20px", fontFamily: "Inter" }}>
//         Blood Donation
//       </h2>
//       <p style={{ fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         The Blood Donation Camp, initiated by TISSAA in collaboration with HDFC Bank and Tata Memorial Hospital, was a
//         significant step in promoting social responsibility. Inaugurated by TISS Vice Chancellor Prof. Shalini Bharat,
//         the camp saw the active participation of Alums such as Prof. Bipin Jojo, Mahesh Poojary, Dr. Nitin Lata, and
//         Waman, demonstrating the collective commitment of the TISS community to supporting public health initiatives and
//         contributing to the welfare of society.
//       </p>

//       <div style={styles.imageContainer}>
//         <img src={img41} alt="Alumni Meet 1" style={{ ...styles.image, height: '500px' }} />
//         <img src={img42} alt="Alumni Meet 1" style={{ ...styles.image, height: '400px' }} />
//         <img src={img43} alt="Alumni Meet 1" style={{ ...styles.image, height: '400px' }} />
//         <img src={img44} alt="Alumni Meet 1" style={{ ...styles.image, height: '400px' }} />
//         <img src={img45} alt="Alumni Meet 1" style={{ ...styles.image, height: '295px' }} />
//         <img src={img46} alt="Alumni Meet 1" style={{ ...styles.image, height: '295px' }} />
//       </div>
//     </div>


//   );
// };


// const styles = {
//   imageContainer: {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
//     gap: '15px',
//     marginBottom: '40px',
//     justifyItems: 'center',
//   },
//   image: {
//     width: '100%',
//     height: 'auto',
//     borderRadius: '8px',
//     boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//     transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//   },
//   imageHover: {
//     transform: 'scale(1.05)',
//     boxShadow: '0 6px 16px rgba(0, 0, 0, 0.15)',
//   }
// };

// export default AlumsCare;
